import React, { useCallback, useContext } from "react";
import { IFailureTypesButtonsProps } from "../FailureDetailsInterfaces";
import { IFailureType } from "../../../../../contexts/HMICachedDataContext/HMICachedDataContextInterfaces";
import { HMIContext } from "../../../../../contexts/HMIContext/HMIContext";
import { FailureDetailsButton } from "../../../../../components/FailureDetailsButton/FailureDetailsButton.view";
import { useStyles } from "../FailureDetails.styles";
import { Grid } from "@mui/material";
import {
    DefaultTranslationFieldsInTable,
    FAILUREDETAILSSTEPS,
    FAILURE_TYPES_CODE_EXCEPTIONS,
} from "../../../../../constants/constants";
import { setCurrentFailureType } from "../../../../../utilities/storageUtilities";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { useTranslation } from "react-i18next";

export const FailureTypeButtons = ({ failureTypes }: IFailureTypesButtonsProps) => {
    const {
        handleFailureTypeChange,
        handleNextFailureDetailsStep,
        handleSetFailureDetailStep,
        handleArea,
        handleFunctionalLocation,
    } = useContext(HMIContext);
    const classes = useStyles();
    const { i18n } = useTranslation();

    const handleFailureType = useCallback(
        (failureType: IFailureType) => {
            return (event: React.MouseEvent) => {
                event.preventDefault();
                handleFailureTypeChange(failureType);
                setCurrentFailureType(failureType);

                if (failureType.is_location_specific) {
                    handleNextFailureDetailsStep();
                } else {
                    handleSetFailureDetailStep(FAILUREDETAILSSTEPS.FAILURECODES);
                    handleArea(undefined);
                    handleFunctionalLocation(undefined);
                }
            };
        },
        [
            handleFailureTypeChange,
            handleNextFailureDetailsStep,
            handleSetFailureDetailStep,
            handleArea,
            handleFunctionalLocation,
        ],
    );

    return (
        <Grid container className={classes.failureButtonsContainer}>
            {failureTypes
                .filter(
                    (failureType) =>
                        failureType.code !== FAILURE_TYPES_CODE_EXCEPTIONS.NOT_SELECTED &&
                        failureType.code !== FAILURE_TYPES_CODE_EXCEPTIONS.BELOW_TRIGGER,
                )
                .map((failureType: IFailureType) => {
                    return (
                        <Grid item xs={5.8} key={failureType.failure_type_id}>
                            <FailureDetailsButton
                                onClick={handleFailureType(failureType)}
                                name={
                                    translateDefaultEntity(
                                        i18n.language,
                                        failureType,
                                        "name",
                                        DefaultTranslationFieldsInTable.FAILURE_TYPE,
                                    ) as string
                                }
                                color={failureType.color_code}
                            />
                        </Grid>
                    );
                })}
        </Grid>
    );
};
